"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _pickReactKnownProp = require("pick-react-known-prop");

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: (0, _defineProperty2.default)({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: theme.palette.secondary.adornment.primary,
      color: theme.palette.common.white,
      fontWeight: 600,
      fontSize: 13,
      whiteSpace: 'nowrap',
      textTransform: theme.text.textTransformUppercase,
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5),
      borderRadius: 3,
      '&:not(:last-of-type)': {
        marginRight: theme.spacing(1.5)
      }
    }, theme.breakpoints.down('xs'), {
      marginTop: theme.spacing(1)
    }),
    'adornment-freeShipping': {
      backgroundColor: theme.palette.secondary.adornment.blue
    }
  };
}, {
  name: 'ProductDetailAdornment'
});

function ProductDetailAdornment(_ref) {
  var children = _ref.children,
      pClasses = _ref.classes,
      className = _ref.className,
      type = _ref.type,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["children", "classes", "className", "type"]);
  var classes = useStyles({
    classes: pClasses
  });
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, classes["adornment-".concat(type)], className)
  }), children);
}

process.env.NODE_ENV !== "production" ? ProductDetailAdornment.propTypes = {
  children: _propTypes.default.node,
  classes: _propTypes.default.shape({
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  type: _propTypes.default.string
} : void 0;
ProductDetailAdornment.defaultProps = {
  children: null,
  classes: undefined,
  className: undefined,
  type: undefined
};
var _default = ProductDetailAdornment;
exports.default = _default;